import { cn } from '@/utils/mergeClassName';

type HtmlBlockProps = {
  html?: string;
  className?: string;
};

export const HtmlBlock = ({ html, className }: HtmlBlockProps) => {
  return (
    <div
      className={cn(
        'text-grey-700 [&_a]:text-blue-300 [&_a]:underline [&_h1]:font-publico [&_h1]:text-[2rem] [&_h1]:font-bold [&_h1]:leading-10 [&_h2]:font-publico [&_h2]:text-2xl [&_h2]:font-bold [&_h3]:font-publico [&_h3]:text-xl [&_h3]:font-[500] [&_h4]:text-xl [&_h4]:font-semibold [&_ol]:ml-6 [&_ol]:list-decimal [&_ul]:ml-6 [&_ul]:list-inside [&_ul]:list-disc',
        className
      )}
      dangerouslySetInnerHTML={{ __html: html ?? '' }}
    />
  );
};
